export default __webpack_public_path__ + "static/media/get_surrounding_objects_modal.c765f9d8.png";